// EmailJS Configuration
// Vervang deze waarden met je eigen EmailJS instellingen

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_qrey7bp', // Je EmailJS Service ID
  TEMPLATE_ID: 'template_24di17t', // Je EmailJS Template ID
  PUBLIC_KEY: '0mf45dk9ffc1KBcod', // Je EmailJS Public Key
  TO_EMAIL: 'pierrelmdeboer@gmail.com' // Ontvanger email
};

// EmailJS initialisatie
export const initEmailJS = () => {
  // EmailJS wordt automatisch geïnitialiseerd wanneer je de library importeert
  // Geen extra configuratie nodig
}; 